import * as turf from '@turf/turf'

interface ICoordinates {
  latitude: number
  longitude: number
}

// Nearest item to `target` by great-circle distance. Items whose accessor
// returns no coordinates are skipped; null when nothing qualifies.
export function nearestByDistance<T>(
  items: readonly T[],
  target: ICoordinates,
  getCoordinates: (item: T) => ICoordinates | null | undefined,
): T | null {
  return (items ?? []).reduce<{ item: T | null; distance: number }>(
    (closest, item) => {
      const coordinates = getCoordinates(item)
      if (!coordinates) {
        return closest
      }
      const distance = turf.distance(
        [target.longitude, target.latitude],
        [coordinates.longitude, coordinates.latitude],
      )
      return distance < closest.distance ? { item, distance } : closest
    },
    { item: null, distance: Infinity },
  ).item
}
